(ns frontend.ui.component.rich-text-editor.style
  (:require
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]
   [herb.core :refer [defglobal]]))

;; Remember that these styles override react-draft-wysiwyg's own stylesheet
(defglobal
 rich-text-editor
 [:.rdw-editor-wrapper
  {:padding   "8px 0"
   :font-size "13px"}]
 [:.rdw-editor-main]
 [:.rdw-editor-toolbar
  {:display       "flex"
   :padding       "6px 12px"
   :border-radius "4px 4px 0 0"
   ;; First cancelling default react-draft-wysiwyg border style
   :border        (space-join ["1px" "solid" (theme/color [:rich-text-editor :toolbar :border-bottom])])}
  :border-bottom :none]
 [:.rdw-editor-main
  {:border        (space-join ["1px" "solid" (theme/color [:rich-text-editor :toolbar :border-bottom])])
   :background    (theme/color [:rich-text-editor :bg])
   :border-radius "4px"
   :padding       (theme/edge-size :xxsmall)
   :height        "auto"}]
)

(defn padding-top
  []
  {:padding-top (theme/edge-size :xxsmall)})

(defn link-popup
  []
  ^{:combinators {[:> :.rdw-link-modal-target-option]
                  {:display :none}
                  [:> :.rdw-link-modal-input]
                  {:margin-bottom "20px !important"}
                  [:> ".rdw-link-modal-buttonsection" ".rdw-link-modal-btn:not(:disabled):first-child"]
                  {:background "#8ABF4C !important"
                   :color      :white
                   :border     :none
                   :box-shadow :none}
                  [:> ".rdw-link-modal-buttonsection" ".rdw-link-modal-btn:not(:disabled):first-child:hover"]
                  {:background "#709f39 !important"}}}
  {:height :auto})
